import { configure, validateAll, extend } from "indicative/validator"

// import custom validations
import CUSTOM_VALIDATION_E164 from "./custom/e164"
// configure props
configure({ existyStrict: true })
// extends custom validations
CUSTOM_VALIDATION_E164(extend)

const parseSchema = (schema) => {
  const parsedSchema = {}
  for (const key in schema) {
    parsedSchema[key] = Object.keys(schema[key]).join("|")
  }
  return parsedSchema
}

const parseError = (errors) => {
  const parsedError = {}
  for (const error of errors) {
    // if already exists a field error
    // keep the first message
    if (!parsedError[error.field])
      parsedError[error.field] = error.message
  }
  return parsedError
}

const parseMessage = (schema) => {
  const parsedMessage = {}
  for (const key in schema) {
    for (const validation in schema[key]) {
      parsedMessage[`${key}.${validation}`] = schema[key][validation]
    }
  }
  return parsedMessage
}

export const validate = async (data, schema) => {
  return new Promise(async (resolve, reject) => {
    try {
      await validateAll(data, parseSchema(schema), parseMessage(schema))
      return resolve(true)
    } catch (error) {
      if (error.constructor.name === "Array") return resolve(parseError(error))
      else return reject(error)
    }
  })

}